import { render, staticRenderFns } from "./Statistics.html?vue&type=template&id=67bc98f7&external"
import script from "./Statistics.ts?vue&type=script&lang=ts&external"
export * from "./Statistics.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports